module.exports = __webpack_public_path__ + "static/img/activity_sdy_07-3.cbf3d27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sydney/images/activity/activity_sdy_07-3.jpg
// module id = gY+x
// module chunks = 0